"use client";

import { atom, useAtom, useAtomValue } from "jotai";
import { useEffect } from "react";

import { equityModalTabAtom } from "./equityModalTab";
import { showEquityModalAtom } from "./showEquityModal";

export const isEquityModalEditingAtom = atom(false);

export const useIsEquityModalEditing = () => {
  const [isEquityModalEditing, setIsEquityModalEditing] = useAtom(
    isEquityModalEditingAtom,
  );
  const showEquityModal = useAtomValue(showEquityModalAtom);
  const equityModalTab = useAtomValue(equityModalTabAtom);

  useEffect(() => {
    if (showEquityModal) return;

    setIsEquityModalEditing(false);
  }, [showEquityModal, setIsEquityModalEditing]);

  useEffect(() => {
    setIsEquityModalEditing(false);
  }, [equityModalTab, setIsEquityModalEditing]);

  return {
    isEquityModalEditing,
    setIsEquityModalEditing,
  };
};
